module.exports = __webpack_public_path__ + "static/media/elogo.df169e03.png";